import React from 'react'
import * as S from './styles'

import { PAGE_PATHS } from '@/services/paths'
import { EVENT_KEYS, sendToDataLayer } from '@/services/events'

import { useTranslation } from 'react-i18next'

const conclusionImg = `${process.env.CDN_URL}/public/contents/banner_doctors.webp`

const BannerOutro = () => {
  const { t } = useTranslation()

  const requestDemoCallback = () => {
    sendToDataLayer({
      event: EVENT_KEYS.requestDemo
    })
  }

  return (
    <S.BannerOutroContainer id="banner_outro" bg={conclusionImg}>
      <div className="filter overlay"></div>
      <div className="text-container">
        <h2 className="title">{t('contents.conclusion')}</h2>
        <a
          href={PAGE_PATHS.contact}
          id="btn_contact_1"
          className="btn orange xl mx-auto desktop"
          onClick={requestDemoCallback}
        >
          {t('buttons.demo')}
        </a>
        <a
          href={PAGE_PATHS.contact}
          id="btn_contact_2"
          className="btn orange lg mx-auto mobile"
          onClick={requestDemoCallback}
        >
          {t('buttons.demo')}
        </a>
      </div>
    </S.BannerOutroContainer>
  )
}

export default BannerOutro
